import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

import { ToolTip } from "~/common/components";
import {
  OrganizationNotifyListResponse,
  OrganizationProvidersResponse,
} from "~/providers/types/teamMembers";
import { UnassignedConsultationsNotifyListModal } from "./UnassignedConsultationsNotifyListModal";

interface UnassignedConsultationsNotifyListProps {
  notifyList: OrganizationNotifyListResponse;
  availableProviders: OrganizationProvidersResponse[];
}

export const UnassignedConsultationsNotifyList = ({
  notifyList,
  availableProviders,
}: UnassignedConsultationsNotifyListProps) => {
  const stringifiedNotifyList =
    notifyList.notify_list.length > 0
      ? notifyList.notify_list.map((item) => item.full_name).join(", ")
      : "None";

  return (
    <div className="flex w-full flex-col gap-3 rounded-lg border px-5 py-6 shadow-inner shadow-gray-50 transition-all duration-700">
      <div className="flex flex-row justify-between">
        <h2 className="flex items-center gap-1 text-lg font-semibold text-gray-800">
          Notify list for unassigned consultations
          <ToolTip
            className="bg-neutral-25 p-3.5"
            arrowClassName="bg-neutral-25"
            tooltip={
              <div className="flex flex-col gap-2 text-gray-600">
                <p className="font-semibold">
                  Notify list for unassigned consultations
                </p>
                <div className="flex flex-col gap-4">
                  <p>
                    These individuals will receive notifications regarding
                    consultations whose primary provider is unassigned.
                  </p>
                </div>
              </div>
            }
          >
            <ExclamationCircleIcon className="h-5 w-5 rotate-180 stroke-2 text-gray-60" />
          </ToolTip>
        </h2>
        <UnassignedConsultationsNotifyListModal
          notifyList={notifyList}
          availableProviders={availableProviders}
        />
      </div>
      {notifyList.setting === "admins" ? (
        <p>
          <span className="font-medium">Organization admins</span>
          {` (${stringifiedNotifyList})`}
        </p>
      ) : (
        <p>{stringifiedNotifyList}</p>
      )}
    </div>
  );
};
